// extracted by mini-css-extract-plugin
module.exports = {"block":"_14766","title":"_9233","list":"_15447","item":"_11920","cover":"_18424","name":"_1583","price":"_11525","current":"_17679","cost":"_436"};